import type { ShopUrgency } from '../../lib/scheduleAnalyzer'

interface Props {
  outCount:     number
  lowCount:     number
  usedCount:    number
  stockedCount: number
  filter?:      string[]
  shopUrgency?: ShopUrgency
}

interface PillProps {
  count: number
  label: string
  bg:    string
  color: string
}

function Pill({ count, label, bg, color }: PillProps) {
  return (
    <span
      style={{ backgroundColor: bg, color }}
      className="px-3 py-1 rounded-full text-xs font-semibold"
    >
      {count} {label}
    </span>
  )
}

export default function SummaryBar({ outCount, lowCount, usedCount, stockedCount, filter, shopUrgency }: Props) {
  const show = (key: string) => !filter || filter.includes(key)

  // Derive shop pill styling from urgency
  let shopBg    = '#F2EDE6'
  let shopColor = '#7A7468'
  let pulse     = false

  if (shopUrgency) {
    if (shopUrgency.urgency === 'soon') {
      const days = shopUrgency.daysUntilShop ?? 99
      if (days <= 0) {
        shopBg    = '#FAEAE8'
        shopColor = '#C25B4E'
        pulse     = true
      } else {
        shopBg    = '#FAEAE8'
        shopColor = '#C25B4E'
      }
    } else if (shopUrgency.urgency === 'upcoming') {
      shopBg    = '#FDF0E3'
      shopColor = '#D4863A'
    }
    // 'later' and 'unknown' use the default gray styling above
  }

  return (
    <div className="flex gap-2 flex-wrap px-4 py-3 items-center">
      {show('out')     && <Pill count={outCount}     label="out"     bg="#FAEAE8" color="#C25B4E" />}
      {show('low')     && <Pill count={lowCount}     label="low"     bg="#FDF0E3" color="#D4863A" />}
      {show('used')    && <Pill count={usedCount}    label="used"    bg="#E8F2FF" color="#4A90D9" />}
      {show('stocked') && <Pill count={stockedCount} label="stocked" bg="#E8F2EA" color="#6B9E78" />}

      {shopUrgency && (
        <span
          className={`px-3 py-1 rounded-full text-xs font-semibold ${pulse ? 'animate-pulse' : ''}`}
          style={{ backgroundColor: shopBg, color: shopColor }}
        >
          🛒 {shopUrgency.label}
        </span>
      )}
    </div>
  )
}
